// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-strength {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: .5rem .75rem;
    margin-top: -.45rem;
}

.password-strength span {
    display: flex;
    align-items: center;
    gap: .45rem;
    color: #8b98a7;
    font-size: .75rem;
    transition: color .2s ease;
}

.password-strength span i {
    display: grid;
    place-items: center;
    width: 1.05rem;
    height: 1.05rem;
    border-radius: 999px;
    color: transparent;
    font-size: .55rem;
    background: #e7ecf0;
    transition: color .2s ease, background .2s ease;
}

.password-strength span.met {
    color: #257653;
}

.password-strength span.met i {
    color: #fff;
    background: #2f9b70;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/ResetPassword/ResetPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".password-strength {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: .5rem .75rem;\n    margin-top: -.45rem;\n}\n\n.password-strength span {\n    display: flex;\n    align-items: center;\n    gap: .45rem;\n    color: #8b98a7;\n    font-size: .75rem;\n    transition: color .2s ease;\n}\n\n.password-strength span i {\n    display: grid;\n    place-items: center;\n    width: 1.05rem;\n    height: 1.05rem;\n    border-radius: 999px;\n    color: transparent;\n    font-size: .55rem;\n    background: #e7ecf0;\n    transition: color .2s ease, background .2s ease;\n}\n\n.password-strength span.met {\n    color: #257653;\n}\n\n.password-strength span.met i {\n    color: #fff;\n    background: #2f9b70;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
